import { RunningSumWindow } from "../utils/CircularBuffer";
import type { MutableArrayLike } from "../utils/MutableArrayLike";

const timers = new Map<string, number>();
export function createWindowTimerFunctions() {
  window.time = (label) => {
    timers.set(label, performance.now());
  };
  window.timeEnd = (label) => {
    const startTime = timers.get(label);
    if (startTime) {
      console.log(`${label}: ${performance.now() - startTime} ms`);
      timers.delete(label);
    }
  };
}

export function logElapsedTime(target: unknown, propertyKey: string, descriptor: PropertyDescriptor) {
  const method = descriptor.value;
  if (method == undefined) return;
  descriptor.value = function (...args: unknown[]) {
    window.time(propertyKey);
    const result = method.apply(this, args);
    window.timeEnd(propertyKey);
    return result;
  };
}

export function logAverageElapsedTime(
  /** Amount of data in window, or buffer of needed size to use (e.g. new Uint8Array()). */
  buffer: number | MutableArrayLike<number> = 30,
  /** Interval to log, in ms. */
  logInterval_ms = 1000
) {
  return function (_target: unknown, propertyKey: string, descriptor: PropertyDescriptor) {
    const method = descriptor.value;
    if (method == undefined) return;
    const rs = new RunningSumWindow(buffer, 0);
    let tUpdate = window.performance.now();
    let tLog = logInterval_ms;
    descriptor.value = function (...args: unknown[]) {
      // Time the method.
      const t0 = window.performance.now();
      const result = method.apply(this, args);
      const t1 = window.performance.now();
      rs.update(t1 - t0);
      // If enough time has elapsed, log the average.
      if ((tLog -= t1 - tUpdate) <= 0) {
        tLog += logInterval_ms;
        console.log("\u23F1", this.constructor.name, propertyKey, rs.sum / rs.length);
      }
      tUpdate = t1;
      return result;
    };
  };
}

export function microBench(
  text: string,
  benchFunc: () => void,
  numberOfRuns: number,
  before?: () => void,
  after?: () => void
) {
  const timings = [];
  for (let i = 0; i < numberOfRuns; ++i) {
    before?.();
    const start = window.performance.now();
    benchFunc();
    const end = window.performance.now();
    after?.();
    timings.push(end - start);
  }
  const sum = timings.reduce((prev, curr) => {
    return prev + curr;
  });
  console.log(text, sum / numberOfRuns);
}
